export const toggle_popup = (bool, tipe) => ({
  type: "TOGGLE_POPUP",
  bool,
  tipe,
});

export const toggle_toast = (bool, msg) => ({
  type: "TOGGLE_TOAST",
  bool,
  msg,
});
